const cartToggle = document.querySelector('.site-header__cart-toggle');

// Add event listener to the cart toggle button
cartToggle.addEventListener('click', function() {

  setTimeout(() => {


    const new_swiper = new Swiper('.swiper-container', {
        slidesPerView: 1, // Enable auto width adjustment
        spaceBetween: 10, // Space between slides
        loop: true,

      });
  }, 3000);
});
// Add to cart 
document.addEventListener('DOMContentLoaded', function () {
    function formatMoney(cents, format = "") {
        if (typeof cents === "string") {
              cents = cents.replace(".", "");
            }
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
            function defaultTo(value2, defaultValue) {
              return value2 == null || value2 !== value2 ? defaultValue : value2;
            }
            function formatWithDelimiters(number, precision, thousands, decimal) {
              precision = defaultTo(precision, 2);
              thousands = defaultTo(thousands, ",");
              decimal = defaultTo(decimal, ".");
              if (isNaN(number) || number == null) {
                return 0;
              }
              number = (number / 100).toFixed(precision);
              let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
              return dollarsAmount + centsAmount;
            }
            let value = "";
            switch (formatString.match(placeholderRegex)[1]) {
              case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
              case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
              case "amount_with_space_separator":
                value = formatWithDelimiters(cents, 2, " ", ".");
                break;
              case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
              case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'", ".");
                break;
              case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ",", ".");
                break;
              case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
              case "amount_no_decimals_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 0, "'");
                break;
            }
            if (formatString.indexOf("with_comma_separator") !== -1) {
              return formatString.replace(placeholderRegex, value);
            } else {
              return formatString.replace(placeholderRegex, value);
            }
          }
    const cartToggle = document.querySelector('.site-header__cart-toggle');
    if (cartToggle) {
        cartToggle.addEventListener('click', () => {
            // Use setTimeout to delay the addition of the "custom-drawer" class by 3 seconds
            setTimeout(() => {
                document.body.classList.add('custom-drawer');
               

                // When the "custom-drawer" class is added, add "new-btn" to each button with the "custom_btn" class
                const addToCartButtons = document.querySelectorAll('.custom_btn');
                addToCartButtons.forEach((button) => {
                    
                    button.classList.add('new-btn');
                    console.log('Added class "new-btn" to button:', button);
                    button.addEventListener('click', async () => { 
                        console.log('click');
                        const productId = button.getAttribute('data-variant-id');    
                                     
                                     const variantSelect = document.getElementById('variant-select');

                                     const addToCartButton = document.getElementById('add-to-cart');

                                     if(document.getElementById('variant-select')) {
                                        // Set the initial variant ID on page load
                                        addToCartButton.setAttribute('data-variant-id', variantSelect.value);
                                     }
                                     
                                     
                                   
                                     // Listen for changes on the select element
                                     variantSelect?.addEventListener('change', function() {
                                       const selectedVariantId = variantSelect.value;
                                       // Update the 'data-variant-id' attribute of the Add to Cart button
                                       addToCartButton.setAttribute('data-variant-id', selectedVariantId);
                                     });


                                    const variantId = button.dataset.variantId;
                                    
                                    
                                    const quantity = 1;
                    
                                    try {
                                        // Make an API call to add the product to the cart
                                        const response = await fetch("/cart/add.js", {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json",
                                                "Accept": "application/json",
                                            },
                                            body: JSON.stringify({
                                                id: variantId || productId, 
                                                quantity: quantity,
                                            }),
                                        });
                    
                                        if (response.ok) {
                                            const result = await response.json();
                                            console.log('Add to cart response:', result);
                                          
                                            $.ajax({
                                                type: 'GET',
                                                url: '/cart.js',
                                                dataType: 'json',
                                                success: function(cart) {
                                                  console.log('Updated Cart:', cart);
                                                  
                                                  // Render cart drawer HTML dynamically
                                                  let cartHtml = '';
                                                  cart.items.forEach((item,index) => {
                                                    let discount = item.discounts ? item.discounts[0] : null;
                                                    
                                                    var number = index + 1;
                                                    cartHtml += `
                                                    <div class="ajaxcart__product">
                                                        <div data-line="${number}" class="ajaxcart__row">
                                                            <div class="grid display-table">
                                                            <!-- Image Section -->
                                                            <div class="grid__item small--one-whole medium--one-quarter large--one-quarter medium--display-table-cell">
                                                                <a href="${item.url}" class="ajaxcart__product-image">
                                                                <img 
                                                                    src="${item.image}" 
                                                                    alt="${item.title}" 
                                                                    srcset="//leafsource.ca/cdn/shop/files/Shilajit_120_f9541209-c55d-48be-89e2-011c11b246c8.png?v=1731868099 0w" 
                                                                    loading="lazy"
                                                                >
                                                                </a>
                                                            </div>

                                                            <!-- Product Details Section -->
                                                            <div class="grid__item small--one-whole medium--two-quarters large--two-quarters medium--display-table-cell">
                                                                <!-- Product Name and Remove Button -->
                                                                <div class="remove_wrapper">
                                                                <a href="${item.url}" class="ajaxcart__product-name">${item.title}</a>
                                                                <button type="button" class="ajaxcart__qty-remove">
                                                                    <img 
                                                                    src="https://cdn.shopify.com/s/files/1/0263/7725/7044/files/Remove_icon_fbda1287-6482-45d3-b2b9-21d27a4847f2.svg?v=1734695323" 
                                                                    alt="Remove"
                                                                    >
                                                                </button>
                                                        </div>

                                                        <!-- Price and Discounts -->
                                                        <div class="price_variant--wrapper">
                                                        <div class="text-center">
                                                            <span class="price-no--discount hide">3900</span>
                                                            <span class="ajaxcart-item__price"><span class="money">${formatMoney(item.price,  '$\{\{amount\}\}')}</span></span>
                                                            <s></s>
                                                        </div>
                                                        </div>
                                                        <ul aria-label="Discount" class="ajaxcart-item__discounts">
                                                        <li class="ajaxcart-item__discount">
                                                            <span class="hide auto-discount--price">${formatMoney(item.price,  '$\{\{amount\}\}')}</span>
                                                            <span class="ajaxcart-item__discount_title">${discount ? discount.title : ''}</span>
                            
                                                            <span class="ajaxcart-item__discount_money">- <span><span class="money">${discount? formatMoney(discount.amount,  '$\{\{amount\}\}') : ""}</span></span></span>
                                                        </li>
                                                        </ul>

                                                        <!-- Quantity Selector -->
                                                        <div class="grid--full ajaxcart__quantity-wrapper">
                                                        <div class="grid__item">
                                                        <div class="ajaxcart__qty">
                                                            <!-- Decrease Quantity Button -->
                                                            <button 
                                                                type="button" 
                                                                class="ajaxcart__qty-adjust ajaxcart__qty--minus icon-fallback-text"
                                                            >
                                                                <svg 
                                                                xmlns="http://www.w3.org/2000/svg" 
                                                                viewBox="0 0 448 512" 
                                                                width="24" 
                                                                height="24" 
                                                                fill="currentColor" 
                                                                aria-hidden="true" 
                                                                class="flex-full"
                                                                >
                                                                <path d="M416 288H384L32 288H0l0-64 32 0 352 0 32 0v64z"></path>
                                                                </svg>
                                                                <span class="fallback-text">−</span>
                                                            </button>

                                                            <!-- Quantity Input -->
                                                            <input 
                                                                type="text" 
                                                                name="updates[]" 
                                                                value="${item.quantity}"
                                                                min="1" 
                                                                aria-label="quantity" 
                                                                pattern="[0-9]*" 
                                                                class="ajaxcart__qty-num"
                                                            >

                                                            <!-- Increase Quantity Button -->
                                                            <button 
                                                                type="button" 
                                                                class="ajaxcart__qty-adjust ajaxcart__qty--plus icon-fallback-text"
                                                            >
                                                                <svg 
                                                                xmlns="http://www.w3.org/2000/svg" 
                                                                viewBox="0 0 448 512" 
                                                                width="24" 
                                                                height="24" 
                                                                fill="currentColor" 
                                                                aria-hidden="true" 
                                                                class="flex-full"
                                                                >
                                                                <path d="M240 80V48H176V80 224H32 0v64H32 176V432v32h64V432 288H384h32V224H384 240V80z"></path>
                                                                </svg>
                                                                <span class="fallback-text">+</span>
                                                            </button>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>


                                                    `;
                                                  });
                                            
                                                  // Update the cart drawer content
                                                  $('.ajaxproduct_wrap').html(cartHtml);
                                            
                                                  // Update cart count
                                                //   $('.cart-count').text(cart.item_count);
                                            
                                                //   // Open the cart drawer
                                                //   $('.cart-drawer').addClass('open');
                                                },
                                                error: function(error) {
                                                  console.log('Error updating cart drawer:', error);
                                                }
                                              });
                                            
                                        
                                            
                                        } else {
                                            const error = await response.json();
                                            console.error('Failed to add to cart:', error);
                                            alert(error.message || 'Failed to add product to cart. Please try again.');
                                        }
                                        
                                    } catch (error) {
                                        console.error('Error adding to cart:', error);
                                        alert('An error occurred. Please try again.');
                                    }


                    });
                });
            }, 3000); 
        });
    } else {
        console.error('Element with class "site-header__cart-toggle" not found.');
    }
});
   

